import React, { useState } from 'react';
import './room4.css';

const TARGET_HOUR = 11;
const TARGET_MINUTE = 0;

const ClockPuzzle = ({ onClose, onSolve }) => {
  const [hour, setHour] = useState(12);
  const [minute, setMinute] = useState(0);
  const [error, setError] = useState(false);

  const checkTime = () => {
    if (
      hour === TARGET_HOUR &&
      minute === TARGET_MINUTE
    ) {
      onSolve();
    } else {
      setError(true);

      setTimeout(() => {
        setError(false);
      }, 800);
    }
  };

  return (
    <div className="puzzleoverlay" onClick={onClose}>
      <div
        className={`puzzlemodal clockmodal ${
          error ? 'puzzleshake' : ''
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="puzzleclose"
          onClick={onClose}
        >
          ✕
        </button>

        <h2 className="puzzletitle">
  THE GRANDFATHER CLOCK
</h2>

<p className="puzzlesubtitle">
  The hands have stopped moving.
  <br />
  <strong>
    Read the clue hidden in the room and restore the correct time.
  </strong>
</p>

<div className="clockpuzzlecontainer">
  <div className="clocktime">
    {String(hour).padStart(2, '0')}:
    {String(minute).padStart(2, '0')}
  </div>

  <div className="clockcontrols">
    <button
      className="clockbutton"
      onClick={() =>
        setHour((prev) =>
          prev === 12 ? 1 : prev + 1
        )
      }
    >
      ▲ Hour Hand
    </button>

    <button
      className="clockbutton"
      onClick={() =>
        setMinute((prev) => {
          const next = prev + 5;

          if (next >= 60) {
            setHour((h) =>
              h === 12 ? 1 : h + 1
            );
            return 0;
          }

          return next;
        })
      }
    >
      ▲ Minute Hand
    </button>
  </div>

  <button
    className="puzzlesubmit"
    onClick={checkTime}
  >
    CONFIRM TIME
  </button>

  {error && (
    <p className="puzzleerror">
      The clock gives no response.
    </p>
  )}
</div>
      
      </div>
    </div>
  );
};

export default ClockPuzzle;